/* Jewelgalore theme — global JS */
(function () {
  'use strict';

  /* ---------- Hero slider dots + counter ---------- */
  function initHero() {
    var dots = document.querySelectorAll('.slide-ind .s-dot');
    var numEl = document.querySelector('.hero-number');
    if (!dots.length) return;
    var total = dots.length;
    var cur = 0;

    function go(n) {
      dots[cur].classList.remove('active');
      cur = n;
      dots[cur].classList.add('active');
      if (numEl) {
        numEl.textContent = ('0' + (cur + 1)).slice(-2) + ' / ' + ('0' + total).slice(-2);
      }
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    if (total > 1) setInterval(function () { go((cur + 1) % total); }, 5000);
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var targets = document.querySelectorAll('.cat, .c-card, .b-item, .leg-stat, .card');
    if (!targets.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    targets.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity .55s ease, transform .55s ease';
      io.observe(el);
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var burger = document.querySelector('.h-burger');
    var drawer = document.querySelector('.m-drawer');
    if (!burger || !drawer) return;
    var close = drawer.querySelector('.m-close');
    burger.addEventListener('click', function () { drawer.classList.add('open'); });
    if (close) close.addEventListener('click', function () { drawer.classList.remove('open'); });
  }

  /* ---------- Product gallery thumbnails ---------- */
  function initGallery() {
    var thumbs = document.querySelectorAll('.p-thumb');
    var main = document.querySelector('.p-main-img img');
    if (!thumbs.length || !main) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-full');
        if (src) main.src = src;
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQty() {
    document.querySelectorAll('.p-qty').forEach(function (q) {
      var input = q.querySelector('input');
      var minus = q.querySelector('[data-qty="minus"]');
      var plus = q.querySelector('[data-qty="plus"]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var data = document.getElementById('product-json');
    if (!data) return;
    var product;
    try { product = JSON.parse(data.textContent); } catch (e) { return; }

    var selected = {};
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('.p-price .now');
    var addBtn = form.querySelector('[data-add]');

    // init defaults from first available variant
    if (product.variants && product.variants[0]) {
      product.variants[0].options.forEach(function (v, i) { selected[i] = v; });
    }

    function update() {
      var match = product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) { return selected[i] === opt; });
      });
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? (addBtn.getAttribute('data-label') || 'Add to Cart') : 'Sold Out';
        }
      }
    }

    form.querySelectorAll('.p-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var idx = parseInt(sw.getAttribute('data-opt-index'), 10);
        var val = sw.getAttribute('data-opt-value');
        selected[idx] = val;
        form.querySelectorAll('.p-swatch[data-opt-index="' + idx + '"]').forEach(function (s) {
          s.classList.remove('active');
        });
        sw.classList.add('active');
        update();
      });
    });
    update();
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var sym = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return sym ? sym + ' ' + amount : amount;
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initHero();
    initReveal();
    initDrawer();
    initGallery();
    initQty();
    initVariants();
  });
})();
